import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
@Entity('ap_settings')

export class AppSettingEntity {  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("varchar",{
    nullable:true,
    length:2000,
    name:'type'
  })
  type:string;
  @Column("int",{
    nullable:false,
    default:0,
    name:"status"    
  })
  status:number;
  
}